/**
 * Formulaires HubSpot : [data-hubspot-form] avec id, data-region, data-portal-id, data-form-id.
 * Le script HubSpot (js.hsforms.net, enqueue dans le head) doit être chargé ; s'il arrive en
 * retard (consentement, réseau), on réessaie pendant 10 secondes.
 * Remplace le composant Vue HubspotForm.
 */
UNYC.register('hubspot-form', () => {
    const ready = () => Boolean(window.hbspt && window.hbspt.forms);

    const create = (el) => {
        const { region, portalId, formId } = el.dataset;
        const id = el.getAttribute('id');

        if (!(region && id && portalId && formId)) return;

        window.hbspt.forms.create({
            target: `#${id}`,
            portalId,
            formId,
            region,
        });
    };

    UNYC.init('[data-hubspot-form]', 'hubspot-form', (el) => {
        let attempts = 0;

        const tryCreate = () => {
            if (ready()) {
                create(el);
            } else if (attempts < 20) {
                attempts += 1;
                window.setTimeout(tryCreate, 500);
            }
        };

        tryCreate();
    });
});
